import PropTypes from 'prop-types';
import { load } from 'model/scheduledTransactionAudit';
import {
  selectorCount,
  selectorGroupedByDays,
} from 'selectors/scheduledTransactionAudit';
import Audit from 'components/common/Audit';
import AuditDetailRowRecord from 'components/common/Audit/config/shared/AuditDetailRowRecord';
import GuestHistoryAuditTitle from './GuestHistoryAuditTitle';

const GuestHistoryAudit = ({ buttonLabel, item }) => {
  if (!item?.id) return null;

  return (
    <Audit
      action={load}
      buttonLabel={buttonLabel}
      countSelector={selectorCount}
      item={item}
      Row={AuditDetailRowRecord}
      selectorGroupedByDays={selectorGroupedByDays}
      selectorProps={{ id: item.schedId }}
      Title={GuestHistoryAuditTitle}
    />
  );
};

GuestHistoryAudit.propTypes = {
  buttonLabel: PropTypes.string,
  item: PropTypes.object,
};

GuestHistoryAudit.defaultProps = {
  buttonLabel: null,
  item: null,
};

export default GuestHistoryAudit;
